export class CacheService {
  storage;
  
  key;
  
  constructor() {
    this.storage = new Map();
  }
  
  setKey(key) {
    this.key = key;
  }
}